import { Box } from "@mui/material";

export const AnimatedIcon = ({
	children,
	type = "popFade",
	duration = "1s",
	animate = false,
	completed = false,
}) => (
	<Box
		sx={(theme) => ({
			color: completed ? "#fff" : theme.palette.primary.main,
			width: 32,
			height: 32,
			display: "flex",
			borderRadius: "50%",
			border: "solid 1px",
			borderColor: theme.palette.primary.main,
			justifyContent: "center",
			alignItems: "center",
			backgroundColor: completed ? theme.palette.primary.main : "white",
			transition: "background-color 0.3s ease-in-out",
		})}
	>
		<Box
			sx={{
				display: "inline-flex",
				...(animate && {
					animation: `${type} ${duration} ease-out infinite`,
				}),

				...(animate && {
					[`@keyframes ${type}`]:
						type === "moveX"
							? {
									"0%": { transform: "translateX(-5px)" },
									"50%": { transform: "translateX(0px)" },
									"100%": { transform: "translateX(-5px)" },
							  }
							: type === "wiggle"
							? {
									"0%, 100%": { transform: "rotate(-3deg)" },
									"50%": { transform: "rotate(3deg)" },
							  }
							: type === "popFade"
							? {
									"0%": {
										opacity: 0,
										transform: "scale(0.5)",
									},
									"100%": {
										opacity: 1,
										transform: "scale(1)",
									},
							  }
							: type === "bounce"
							? {
									"0%": { transform: "scale(0.3)" },
									"50%": { transform: "scale(1.2)" },
									"100%": { transform: "scale(1)" },
							  }
							: type === "spin"
							? {
									"0%": {
										transform: "rotate(0deg)",
									},
									"100%": {
										transform: "rotate(360deg)",
									},
							  }
							: {},
				}),
			}}
		>
			{children}
		</Box>
	</Box>
);
